const dict = {
  chooseLang: "Choisir la langue",
  agree: "Accepter",

  //Licence
  instructions: "Instructions",
  step1: "Étape 1 : Scannez le code QR",
  locateqr: "Repérez le code QR sur votre droite.",
  useSmartphone:
    "Utilisez l'appareil photo de votre smartphone ou une application de scan QR pour le scanner. Cela vous amènera à l'étape suivante.",
  step2: "Étape 2 : Saisissez les informations de la playlist",
  afterScan: "Après avoir scanné le code QR, vous serez invité à saisir les informations de votre playlist.",
  makeSure: "Assurez-vous de remplir tous les champs obligatoires.",
  step3: "Étape 3 : Retournez dans l'application",
  onceYou:
    "Une fois que vous avez saisi les détails de votre playlist, vous pouvez revenir à l'application et continuer votre expérience.",
  refresh: "ACTUALISER",
  playlist: "Playlist",
  bigPlaylist: "PLAYLISTS",
  noLicence: "Vous n'avez pas de licence.",
  scanLicence: "Scannez pour acheter une licence.",
  noPlaylist: "Vous n'avez aucune playlist",
  privacyBig: "MODE CONFIDENTIALITÉ",
  scanToAddBig: "SCANNER POUR AJOUTER UNE PLAYLIST",
  scanToBuyBig: "SCANNER POUR ACHETER UNE LICENCE",
  orVisit: "ou visitez",
  andenterdeviceID: "et entrez cet identifiant d'appareil :",
  removePlaylist: "Supprimer la playlist",
  wantToRemove: "Voulez-vous supprimer ?",
  cancelBig: "ANNULER",
  loading: "Chargement...",
  enablePMode: "Veuillez activer le Mode Confidentialité pour continuer à regarder.",
  killSwitchProtecting: "Le Kill Switch protège votre confidentialité en bloquant l'accès lorsque le Mode Confidentialité est désactivé.",
  kSwitchProtecionActive: "Protection Kill Switch Active",
  privacyMode: "Mode Confidentialité",
  ok: "OK",

  //Home
  bigLiveTv: "TV en Direct",
  bigMovies: "Films",
  bigSeries: "Séries",
  //Channel-Menu
  noChannels: "Cette playlist ne contient pas de données de chaînes",
  searchChannels: "Rechercher une chaîne",
  tapToPlay: "Appuyez pour lire le flux vidéo.",
  categoryEmpty: "Cette catégorie est vide",
  pinNotSet: "Code PIN non défini",
  setPinNow: " Souhaitez-vous configurer votre code PIN maintenant ?",
  preview: "APERÇU",
  liveTv: "TV en Direct",
  addToFav: "Ajouter aux Favoris",
  removeFromFav: "Retirer des Favoris",
  now: "En ce moment :",
  nextPlaying: "Prochain :",
  channels: "Chaînes",
  noChannelsFound: "Aucune chaîne trouvée",

  //Movies
  noMovies: "Cette playlist ne contient pas de données de films",
  searchMovies: "Rechercher des films",
  noFavMovies: "Aucun film en favori",
  //series
  noSeries: "Cette playlist ne contient pas de données de séries",
  searchSeries: "Rechercher des séries",
  noFavSeries: "Aucune série en favori",
  search: " Rechercher",
  thereIsProblem: "Il y a un problème en ce moment",
  tryAgainLater: "Veuillez réessayer plus tard.",
  series: "Séries",
  movies: "Films",
  noSeriesFound: "Aucune série trouvée",
  noMoviesFound: "Aucun film trouvé",
  //entity
  play: "LIRE",
  playMovie: "Lire le film",
  recommendations: "Recommandations",
  //User Info
  userInfo: "Informations utilisateur",
  aboutApp: "À propos de l'application",
  //Userinfo
  account: "Compte",
  subscriptions: "Abonnements",
  privacyPilicy: "Confidentialité et Politique",
  languge: "Langue",
  english: "Anglais",
  italian: "Italien",
  german: "Allemand",
  spanish: "Espagnol",
  french: "Français",
  saudiArabia: "Arabe",
  chinese: "Chinois",
  greek: "Grec",
  turkish: "Turc",
  change_pin: "Changer le PIN",
  kill_switch: "Kill Switch",
  device_info: "Informations sur l'appareil",
  unknown: "Inconnu",

  //headers
  settings: "Paramètres",
  termsConditions: "Conditions Générales",
  home: "Accueil",

  //license
  scanQrCode: "Scannez le code QR pour envoyer une playlist",
  managePlaylist: "Gérer la playlist",
  orVisitt: "Ou visitez",
  scanToAdd: "Scannez pour ajouter une playlist ou visitez",

  //device info
  display: "Affichage",
  storage: "Stockage",
  network: "Réseau",
  connection: "Connexion",
  macAddress: "Adresse MAC :",
  deviceId: "ID de l'appareil :",
  pmInfo: "Informations sur le Mode Confidentialité",
  statusActive: "Statut : Actif",
  underMaintance: "Statut : En maintenance",
  version: "Version :",
  lastBuildDate: "Date de dernière compilation :",
  lastUpdated: "Dernière mise à jour : ",

  //kill switch
  enableKillSwitch: "Activer le Kill Switch ?",
  disableKillSwitch: "Désactiver le Kill Switch ?",
  whenEnabled: "Lorsqu'il est activé, OrbixPlay fonctionnera UNIQUEMENT lorsque le Mode Confidentialité est activé.",
  withOrWithoutPM: "OrbixPlay fonctionnera normalement avec ou sans le Mode Confidentialité.",
  extra_privacy_protection: " Protection de la Confidentialité Supplémentaire",
  pmOn: "• Si le Mode Confidentialité est ACTIVÉ : vous pouvez diffuser du contenu en toute sécurité",
  killSwitchDescription: "Le Kill Switch fournit une couche de protection supplémentaire pour une confidentialité maximale.",
  pmOff: "• Si le Mode Confidentialité est DÉSACTIVÉ : l'application bloquera l'accès pour protéger votre confidentialité",
  reenable: "Vous pouvez le réactiver à tout moment pour une sécurité maximale.",
  cancel: "Annuler",
  enable: "Activer",
  disable: "Désactiver",
  killSwitch: "Kill Switch – Protection de la Confidentialité Supplémentaire",
  ipHidden: "Lorsque vous activez le Mode Confidentialité, votre adresse IP est masquée et votre connexion passe par un système sécurisé — similaire au fonctionnement d'un VPN.",
  extraLayer: "Le Kill Switch est une couche de protection supplémentaire : si vous l'activez, OrbixPlay ne fonctionnera que lorsque le Mode Confidentialité est activé.",
  ifPmOn: "• Si le Mode Confidentialité est ACTIVÉ : vous pouvez diffuser du contenu en toute sécurité",
  ifPmOff: "• Si le Mode Confidentialité est DÉSACTIVÉ : l'application bloquera l'accès pour protéger votre confidentialité",
  recommended: "Recommandé pour toute personne souhaitant une sécurité maximale et ne voulant jamais diffuser sans protection.",
  current_status: "Statut actuel :",
  pressToDisable: "🛡️ ACTIVÉ - Appuyez pour désactiver",
  pressToEnable: "○ DÉSACTIVÉ - Appuyez pour activer",
  pressEnter: " Appuyez sur Entrée sur le bouton ci-dessus pour modifier le paramètre Kill Switch",

  //set pin
  pinSetSuccessfully: "Code PIN défini avec succès !",
  createPin: "Créez votre code PIN",
  confirmPin: "Confirmez votre code PIN",
  confirmYourPin: "confirmPin: 'Confirmez votre code PIN'",
  initializingPin: "Initialisation de la configuration du PIN...",
  enterCurrentPin: "Entrez le code PIN actuel",
  enterNewPin: "Entrez le nouveau code PIN",
  confirmNewPin: "Confirmez le nouveau code PIN",
  pinChanged: "Code PIN modifié avec succès !",
  pinHasChanged: " Votre code PIN a été modifié avec succès !",

  //lastones
  playInfo: "Informations sur la playlist",
  playName: "Nom de la playlist :",
  host: "Hôte :",
  username: "Nom d'utilisateur :",
  password: "Mot de passe :",
  packName: "Nom du forfait :",
  expireDate: "Date d'expiration :",

  //privacyPolicy
  one: "1. Avertissement sur le contenu : OrbixPlay est une plateforme conçue pour améliorer votre expérience numérique. Cependant, il est important de noter qu'OrbixPlay n'héberge, ne fournit ni ne distribue de contenu vidéo. Notre service est structuré pour soutenir votre parcours numérique, mais nous ne sommes pas responsables de la disponibilité, de la qualité ou du contenu du matériel vidéo, car cela dépasse le cadre de nos services.",
  two: "2. Aucune responsabilité pour le contenu tiers : OrbixPlay LLC n'est pas responsable du contenu tiers auquel vous pourriez accéder via notre application. Votre engagement avec tout contenu externe, y compris sa légalité, sa fiabilité ou son adéquation, est entièrement à vos propres risques.",
  three:
    "3. Juridiction et Conformité : OrbixPlay LLC opère sous la juridiction des États-Unis. Les utilisateurs sont responsables de s'assurer que leur utilisation de l'application est conforme à toutes les lois locales, étatiques et fédérales.",
  four: "4. Politique de tarification : Les prix des services d'OrbixPlay sont susceptibles d'être modifiés à tout moment sans préavis. En acceptant cet accord, vous reconnaissez et acceptez que les prix peuvent varier et que ces changements n'affecteront pas votre service actuel jusqu'au renouvellement de votre abonnement.",
  five: `5. Absence de garantie : L'application OrbixPlay et ses services sont fournis « tels quels » sans aucune garantie expresse ou implicite, y compris, mais sans s'y limiter, les garanties implicites de qualité marchande, d'adéquation à un usage particulier et de non-contrefaçon.`,
  six: "6. Acceptation des Conditions : En cliquant sur Accepter, vous acceptez d'être lié par les termes de cet avertissement et reconnaissez que toute violation peut entraîner la résiliation de votre accès aux services OrbixPlay.",
  orbixUserAgreement: "ACCORD UTILISATEUR ET AVERTISSEMENT ORBIXPLAY",
  beforeyouProcc: "Avant de continuer, veuillez lire et accepter les termes et conditions suivants :",

  //additional
  exitApp: "Quitter OrbixPlay",
  wantToExit: "Êtes-vous sûr de vouloir quitter OrbixPlay ?",
  Resume: "Reprendre",

  whatsnewinv: "Nouveautés de la version v",
  whatsnew: "Nouveautés",

  resellerInfiniteDevices: "Plan Revendeur : Appareils Illimités",
  resellerInfiniteDevicesDesc: "La même playlist peut désormais être installée sur un nombre illimité d'appareils — pas 5, ni 10, mais autant que vous le souhaitez.",
  thankyouforusingorbixplayenjoythenewfeatures: "Merci d'utiliser OrbixPlay — profitez des nouvelles fonctionnalités !",

  instanthomescreen: "Continuer à regarder",
  instanthomescreendesc: "Reprenez vos séries et films exactement là où vous vous étiez arrêté.",
  turbomoviesearch: "Fonctionnalité Favoris",
  turbomoviesearchdesc: "Enregistrez votre contenu préféré pour un accès rapide et facile à tout moment.",
  lighterondataandbattery: "Stabilité du lecteur améliorée",
  lighterondataandbatterydesc: "Fiabilité de lecture améliorée et opérations de recherche plus fluides.",
  underthehoodfixes: "Corrections en arrière-plan",
  underthehoodfixesdesc: "Diverses corrections de bugs et améliorations des performances pour une meilleure expérience.",

  proxyMaintenance: 'Maintenance du proxy',
  proxyMaintenanceMessage: 'Le serveur proxy est actuellement en maintenance. Veuillez réessayer plus tard.',

  playlistInformation: 'Informations sur la playlist',
  playlistExpDate: 'Date d\'expiration de la playlist : ',
  select_playlist: "Sélectionner une Playlist",
  choose_playlist: "Choisissez une playlist pour commencer à regarder",
  invalid_line: "Ligne Invalide",
  expire_date: "Date d'Expiration :",
  expired: "Expiré",
  waiting_connection: "En attente de connexion...",
  reconnection_attempt: "Tentative de reconnexion",
  try_again: "Réessayer",
  go_back: "Retour",
  unable_to_resume: "Impossible de Reprendre",
  reconnecting: "Reconnexion en cours...",
  no_internet_connection: "Pas de Connexion Internet",
  please_try_again: "Impossible de redémarrer le flux. Veuillez réessayer.",
  restore_stream: "Veuillez patienter pendant que nous rétablissons votre flux.",
  reconnect_automatically: "Vérifiez votre réseau et nous nous reconnecterons automatiquement.",
  check_wifi: "Vérifiez votre connexion WiFi",
  check_ethernet: "Vérifiez votre connexion Ethernet / LAN",
  check_internet: "Vérifiez votre connexion internet",

  add_playlist_screen: "Ajouter une liste",
  add_playlist: "Ajouter une liste manuellement",
  playlist_name_required: "Le nom de la liste est requis",
  m3u_url_required: "L'URL M3U de la liste est requise",
  server_url_required: "L'URL du serveur est requise",
  username_required: "Le nom d'utilisateur est requis",
  password_required: "Le mot de passe est requis",
  orbix_code_required: "Le code hôte Orbix est requis",
  list_code_required: "Le code de liste est requis",
  device_id_required: "L'ID de l'appareil est requis",
  device_id: "ID de l'appareil : ",
  playlist_format: "Format de liste",
  m3u: "URL M3U",
  username_password: "Nom d'utilisateur / Mot de passe",
  orbix_code: "Code Orbix",
  list_code: "Code de liste",
  playListName: "Nom de liste *",
  m3uUrl: "URL de liste M3U *",
  server_URL: "URL du serveur *",
  username_req: "Nom d'utilisateur *",
  password_req: "Mot de passe *",
  orbix_code_req: "Code hôte Orbix *",
  list_code_req: "Code de liste *",
  addPlaylist: "Ajouter une liste",
  adding: "Ajout en cours...",
  my_playlist: "Ma liste",
  username_placeholder: "nom d'utilisateur",
  password_placeholder: "••••••••",

  //stream exceptions
  stream_extension: "Extension de flux",

  //storage_and_data
  storage_and_data: "Stockage & Données",

  // ── Parental PIN ──────────────────────────────────────────────────────────
  enter_parental_pin: "Saisir le PIN parental",

  // ── Account / Subscriptions labels ───────────────────────────────────────
  status: "Statut",
  active: "Actif",
  expiration: "Expiration",
  max_connections: "Max connexions",
  one_device: "1 Appareil",
  created: "Créé",

  // ── Storage & Data screen ─────────────────────────────────────────────────
  section_title: "Stockage & Données",
  section_subtitle: "Gérer les données stockées de l'application",
  favourites_label: "Favoris",
  history_label: "Historique",
  cleared_label: "Effacé",
  all_cleared_label: "Tout effacé",
  remove_cancel_label: "Annuler",
  remove_confirm_label: "Effacer",
  clear_fav_channels_title: "Chaînes favorites",
  clear_fav_channels_subtitle: "Supprimer toutes les chaînes sauvegardées",
  clear_fav_channels_message: "Effacer toutes les chaînes favorites ?",
  clear_fav_movies_title: "Films favoris",
  clear_fav_movies_subtitle: "Supprimer tous les films sauvegardés",
  clear_fav_movies_message: "Effacer tous les films favoris ?",
  clear_fav_series_title: "Séries favorites",
  clear_fav_series_subtitle: "Supprimer toutes les séries sauvegardées",
  clear_fav_series_message: "Effacer toutes les séries favorites ?",
  clear_continue_watching_movies_title: "Continuer à regarder – Films",
  clear_continue_watching_movies_subtitle: "Supprimer la progression des films",
  clear_continue_watching_series_title: "Continuer à regarder – Séries",
  clear_continue_watching_series_subtitle: "Supprimer la progression des séries",
  clear_continue_watching_title: "Continuer à regarder",
  clear_continue_watching_message: "Effacer l'historique de visionnage ?",
  clear_all_title: "Effacer toutes les données",
  clear_all_message: "Cela effacera tous les favoris et l'historique.",

  // ── Stream Extension screen ───────────────────────────────────────────────
  stream_extension_desc: "Choisissez comment les flux en direct sont demandés depuis votre serveur.",
  ts_desc: "Flux MPEG-TS standard",
  m3u8_desc: "Flux adaptatif HLS",
  current: "Actuel",

  // ── Kill Switch modal ─────────────────────────────────────────────────────
  access_restricted: "🛡️ Accès restreint",
  to_access_playlists: "Pour accéder aux playlists :",
  enable_privacy_mode_step: "1. Activez le Mode Confidentialité depuis l'écran principal",
  disable_kill_switch_step: "2. Ou désactivez le Kill Switch dans Paramètres → Kill Switch",
  preparingContent: "Préparation de votre contenu",

  // ── Home screen ──────────────────────────────────────────────────────────────
  loading_base: "Chargement",
  live_now: "EN DIRECT",
  news: "ACTUALITÉS",
  sport: "SPORT",
  kids: "ENFANTS",

  // ── Series details ───────────────────────────────────────────────────────────
  episode: "Épisode",
  no_episodes: "Aucun épisode disponible pour cette saison.",

  searchForChannels: "Rechercher des chaînes...",
  kbSpace: "Espace",
  kbCaps: "Majuscules",
  pressOkToPlay: "Appuyez sur OK pour lire",
  live: "En direct",
};

export default dict;